import { c as _c } from "react/compiler-runtime";
import { FontWeights } from "@flat-ui";
import { Box } from "@mui-wrapper";

/** Tooltip title text */
const TOOLTIP_TITLE = "Switch back?";

/** Tooltip content text */
const TOOLTIP_CONTENT = `By clicking here you will exit the new Dashboard. 
Before you switch, if you could share why you’re leaving we will appreciate. Your feedback helps us improve!`;

/** Renders the tooltip for the HoloBuilder sidebar item */
export function SidebarHolobuilderTooltip() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      padding: "12px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={{
      mb: "10px",
      fontWeight: FontWeights.Bold,
      letterSpacing: "0.48px",
      textTransform: "uppercase"
    }}>{TOOLTIP_TITLE}</Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={t0}>{t1}<Box sx={{
        mb: "10px"
      }}>{TOOLTIP_CONTENT}</Box></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}